<template>
    <div class="mt-6">
       <v-container>            
             <v-form ref="form">
              <v-flex>                  
                 <v-card>
                    <v-card-title class="subtitle-1">{{$t('labels.CLI_ApplicationForm')}}</v-card-title>
                </v-card>
                 <v-card class="mt-2">
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" lg="3" sm="12" md="4">
                             <span class="font-weight-black">{{$t("labels.CLI_ApplicantDetails")}}</span>
                        </v-col>
                         <v-col cols="12" lg="4" sm="6" md="4" v-for="item in applicationDetail.Applicants" v-bind:key="item.ApplicatId">
                            <span v-if="item.PrimaryFl" class="font-weight-black"><strong>{{$t("labels.CLI_PrimaryApplicant")}}</strong></span>
                            <span v-if="!item.PrimaryFl" class="font-weight-black"><strong>{{$t("labels.CLI_CoApplicant")}}</strong></span>                                                                 
                         </v-col>   
                     </v-row>
                      <v-divider></v-divider>   
                      <v-row>
                        <v-col cols="12" lg="3" sm="12" md="4">
                             <span class="font-weight-black"><strong>{{$t("labels.CLI_FirstName")}}</strong></span>
                        </v-col>
                         <v-col cols="12" lg="4" sm="12" md="4" v-for="item in applicationDetail.Applicants" v-bind:key="item.ApplicatId">
                            <span>{{item.FirstName}}</span>                              
                         </v-col>   
                     </v-row>
                      <v-divider></v-divider>   
                      <v-row>
                        <v-col cols="12" lg="3" sm="12" md="4">
                             <span class="font-weight-black"><strong>{{$t("labels.CLI_LastName")}}</strong></span>
                        </v-col>
                         <v-col cols="12" lg="4" sm="6" md="3" v-for="item in applicationDetail.Applicants" v-bind:key="item.ApplicatId">
                            <span>{{item.LastName}}</span>                              
                         </v-col>   
                     </v-row>
                      <v-divider></v-divider>   
                      <v-row>
                        <v-col cols="12" lg="3" sm="12" md="4">
                             <span class="font-weight-black"><strong>{{$t("labels.CLI_EmailAddress")}}</strong></span>
                        </v-col>
                         <v-col cols="12" lg="4" sm="6" md="4" v-for="item in applicationDetail.Applicants" v-bind:key="item.ApplicatId">
                            <span>{{item.EmailAddress}}</span>                              
                         </v-col>   
                     </v-row>
                      <v-divider></v-divider>   
                      <v-row>
                        <v-col cols="12" lg="3" sm="12" md="4">
                             <span class="font-weight-black"><strong>{{$t("labels.CLI_PostalCode")}}</strong></span>
                        </v-col>
                         <v-col cols="12" lg="4" sm="6" md="4" v-for="item in applicationDetail.Applicants" v-bind:key="item.ApplicatId">
                            <span>{{item.AddressDetail.PostalCode}}</span>                              
                         </v-col>   
                     </v-row>
                      <v-divider></v-divider>   
                     <v-row>
                        <v-col cols="12" lg="3" sm="12" md="4">
                             <span class="font-weight-black"><strong><span class="required">{{$t("labels.CLI_Smoker")}}</span></strong></span>
                        </v-col>
                         <v-col cols="12" lg="4" sm="6" md="4" v-for="item in applicationDetail.Applicants" v-bind:key="item.ApplicatId">
                           <v-radio-group row v-model="item.SmokerFl" :rules="[v=>!!v || '']" class="mt-0" @change="profileChanged()">
                               <v-radio :label="$t('labels.CLI_Yes')" value="Y" class="font-weight-regular mt-1"></v-radio>
                               <v-radio :label="$t('labels.CLI_No')" value="N" class="font-weight-regular mt-1"></v-radio>
                          </v-radio-group>                             
                         </v-col>   
                     </v-row>
                      <!-- <v-divider></v-divider>   
                      <v-row>
                        <v-col cols="12" lg="3" sm="12" md="4">
                             <span class="font-weight-black"><strong><span class="required">{{$t("labels.CLI_Gender")}}</span></strong></span>
                        </v-col>
                         <v-col cols="12" lg="4" sm="6" md="4" v-for="item in applicationDetail.Applicants" v-bind:key="item.ApplicatId">
                           <v-radio-group row v-model="item.Gender" :rules="[v=>!!v || '']" @change="profileChanged()">
                               <v-radio :label="$t('labels.CLI_Male')" value="M" class="font-weight-regular mt-1"></v-radio>
                               <v-radio :label="$t('labels.CLI_Female')" value="F" class="font-weight-regular mt-1"></v-radio>
                                <v-radio :label="$t('labels.CLI_Other')" value="O" class="font-weight-regular mt-1"></v-radio>
                          </v-radio-group>                             
                         </v-col>   
                     </v-row> -->
                     <v-divider></v-divider>                   
                    </v-card-text>
                 </v-card> 
                    <c_property :propertyDetail="applicationDetail.PropertyDetail"></c_property>
                    <c_loan ref="loan" :loanDetail="applicationDetail.LoanDetail" :quoteFl="quoteFl"></c_loan>
                    <c_broker :brokerDetail="applicationDetail.BrokerDetail"></c_broker>
                    <c_insurance ref="insuranceApp" 
                      :insuranceDetail="applicationDetail.InsuranceDetail"
                      :loanDetail="applicationDetail.LoanDetail"
                      :generateApplicationFl="generateApplicationFl"
                      :applicants="applicationDetail.Applicants"
                      v-if="showQuote"
                      @getQuote="getQuote()"
                      @coverageChanged="coverageChanged()"></c_insurance>
                      <c_healthQuestions ref="healthQuestions" :applicants="applicationDetail.Applicants" v-if="generateApplicationFl"></c_healthQuestions>
                      <c_payment ref="payment" :paymentDetail="applicationDetail.PaymentDetail" v-if="generateApplicationFl"></c_payment>
                      <!-- <c_insurance_effective ref="insuranceEffectiveDate" :insuranceDetail="applicationDetail.InsuranceDetail" v-if="generateApplicationFl"></c_insurance_effective> -->
                 <v-card class="mt-2">
                     <v-card-actions>
                          <v-spacer></v-spacer>
                            <v-btn dark color="primary" v-show="showGenerateApplicationButton" @click="generateApplication()">{{ $t("labels.Next") }}</v-btn>
                            <v-btn dark color="primary" @click="getQuote()" v-show="showGetQuoteButton">{{ $t("labels.CLI_GetQuote") }}</v-btn>
                            <v-btn dark color="primary" @click="submit()" v-show="showSubmitApplicationButton">{{$t('labels.CLI_Generate')}}</v-btn>
                       </v-card-actions>
                  </v-card>           

              </v-flex>
              </v-form>
              <v-dialog v-model="showErrorAlert" width="500">             
                  <v-card-title class="headline grey lighten-2">
                    {{$t('labels.CLI_ApplicationError')}}
                  </v-card-title>
                  <v-card-text class="grey lighten-2">
                     {{errorMessage}}
                  </v-card-text>                  
                  <v-divider></v-divider>
                    <v-card-actions class="grey lighten-2">
                        <v-spacer></v-spacer>
                        <v-btn dark color="primary" @click="showErrorAlert = false">{{$t('labels.CLI_Close')}}</v-btn>
                     </v-card-actions>
              </v-dialog>  
       </v-container>
        <div class="loading" v-if="loadFlag">Loading&#8230;</div> 
         <!-- <div class="row">{{applicationDetail}}</div> -->
      
    </div>   
</template>
<script>
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import uiSvc from "@/services/uiService";
import domainHelper from "@/services/domainHelper";
import c_healthQuestions from  "./healthquestions";
import c_property from   "./property"
import c_loan from "./loan"
import c_broker from "./broker"
import c_payment from "./paymentaccount"
import c_insurance from "./insurance"
// import c_insurance_effective from "./effectivedate"
export default {
   components:{c_healthQuestions,
    c_property,
    c_loan,
    c_broker,
    c_payment,
    c_insurance,
    //c_insurance_effective
    },
    data(){
        return{         
           loadFlag:false,
           showQuote:false,
           showGenerateApplicationButton:false,
           showSubmitApplicationButton:false,
           generateApplicationFl:false,
           showGetQuoteButton:true,
           quoteFl:false,
           showErrorAlert:false,
           applicationDetail:{
                PropertyDetail:{},
                BrokerDetail:{},
                LoanDetail:{},
                PaymentDetail:{},
                InsuranceDetail:{}
            },
           errorMessage:"",
           siteID: this.$route.params.siteid,
           token: this.$route.params.token,
           mustChecked:v=> v === null || v === undefined  || 'must checked'        
        }
    },
    methods:{
        getLanguage(){
          return localStorageSvc.getLanID()
        },
        scrollToTop() {
            window.scrollTo(0,0);
        },
        validate(errorMessage){
             this.$refs.form.validate();
             this.errorMessage =  errorMessage;
             this.showErrorAlert = true;
        },
        alertError(errorMessage){
             this.errorMessage =  errorMessage;
             this.showErrorAlert = true;
        },
        loadPage(){
             let postData = {
                siteId: this.siteID,
                token: this.token,
                securityQuestion: this.securityQuestion,
                languageId: this.getLanguage()
            };
            this.loadFlag = true;

             dataSvc.getHttp().post(domainHelper.getAPIHost() + "/cli-api/load-application-detail", postData).then((res) => {              
            if (res.data.ReturnStatus.ReturnCode == 200) {
                this.loadFlag = false;
                this.applicationDetail = res.data;  
                this.applicationDetail.applicants = res.data.applicants.sort(function(a, b){ 
                    return b.PrimaryFl ? 1 : -1
                }); 
              
              this.$refs.form.reset()        
            }    
           else if (res.data.ReturnStatus.ReturnCode == 403) {
                this.loadFlag = false;
                 var applicationListPath = "/" + this.siteID + '/cli/application/' + this.token;
                 this.$router.push({path: applicationListPath})                
            }            
            else {      
                this.loadFlag = false;
                this.errorMessage = this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
                this.showErrorAlert = true;
            }                                       
        })
        .catch((err) => {
          this.loadFlag = false;
          uiSvc.alertError(err);
        });
        },
        
      coverageChanged(){
        if(this.generateApplicationFl){
            this.$refs.healthQuestions.reset()
          }
        
        if(this.showSubmitApplicationButton){
            this.generateApplicationFl =  this.applicationDetail.Applicants.some(function(applicant){
                  return !applicant.DeclinedFl
             })  
        }
      },

    generateApplication(){
        this.quoteFl = true;
        this.showGenerateApplicationButton = false;
        this.showSubmitApplicationButton = true;

        this.applicationDetail.Applicants.forEach(applicant => {
            applicant.HealthQuestions.forEach(question=>{
                question.Answer = ""
            })
        });

      this.generateApplicationFl =  this.applicationDetail.Applicants.some(function(applicant){
        return !applicant.DeclinedFl
      })   
      
      //this.scrollToTop();
     },
     profileChanged(){
        if(this.showQuote){
          this.getQuote()
        }
     },
      getQuote(){
            let isValid = true;
            this.isSubmitted = true;
            this.generateApplicationFl = false;
            if(!this.showSubmitApplicationButton && !this.$refs.form.validate()){
             this.alertError(this.$t("errors.CLI_PleaseEnterGetQuoteRequiredInformation"));             
             return;
           }
          let postData = {
              applicationDetail:this.applicationDetail,
              token: this.token,
              languageId:  this.getLanguage()
          }
          this.loadFlag = true;
            dataSvc.getHttp()
             .post(domainHelper.getAPIHost() + "/cli-api/" + this.siteID + "/get-quote", postData)
             .then((res) => {
                   
                if (res.data.ReturnStatus.ReturnCode == 200) {
                    this.loadFlag = false;
                    let applicants = this.applicationDetail.Applicants;
                    for(let index=0; index<applicants.length; index++){
                        let applicant = applicants[index];
                        applicant.InsuranceTypes = res.data.Coverages[applicant.ApplicantId]
                    }       
                    if(this.showQuote){                   
                         this.$refs.insuranceApp.setTotalPreimumAmount()   
                     }            
                    this.showQuote = true;   
                    this.showGetQuoteButton = false;
                    this.showGenerateApplicationButton = !this.showSubmitApplicationButton;   
                     if(this.showSubmitApplicationButton){
                        this.generateApplicationFl =  this.applicationDetail.Applicants.some(function(applicant){
                          return !applicant.DeclinedFl
                        })   
                     }

                    return;      
                    
                } 
                else if(res.data.ReturnStatus.ReturnCode == 422){
                      this.validate(this.$t("errors." + res.data.ReturnStatus.ReturnMessage));
                }
                else {      
                    this.loadFlag = false;
                    this.alertError(this.$t("errors." + res.data.ReturnStatus.ReturnMessage));
                }
                this.loadFlag = false;                              
        })
        .catch((err) => {
          this.loadFlag = false;
           this.alertError(err);
        });
      },
    

      submit(){
          if(!this.$refs.form.validate()){
            this.alertError(this.$t("errors.CLI_PleaseEnterRequiredInformation"));
            return;
          }
          this.loadFlag = true;  
          let postData = {
              siteId: this.siteID,
              token: this.token,
              applicationDetail: this.applicationDetail,
              languageId: this.getLanguage()
          };
          dataSvc.getHttp()
          .post(domainHelper.getAPIHost() + "/cli-api/prepare-application", postData)
          .then((res) => {              
          if (res.data.ReturnStatus.ReturnCode == 200) {
              this.loadFlag = false;
              var applicationListPath = "/" + this.siteID + '/cli/application/' + this.token + '/esign';
              this.$router.push({path: applicationListPath})      
          } 
          else if(res.data.ReturnStatus.ReturnCode == 422){
              this.validate(this.$t("errors." + res.data.ReturnStatus.ReturnMessage));
          }  
          else {      
              this.loadFlag = false;
              this.alertError(this.$t("errors." + res.data.ReturnStatus.ReturnMessage));
            
          }            
          this.loadFlag = false;  
      })
      .catch((err) => {
        this.loadFlag = false;           
        this.alertError(err);
      });
    }
  },
    created(){
        this.loadPage()
    }
}
</script>
<style>
span.required:after,  label.required:after{   
     color: #d00;
     content: "*";
     margin-left: 5px;
     top: 3px;
  }
</style>